'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var THEME = require('pobble-components/dist/theme');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

var THEME__default =
/*#__PURE__*/
_interopDefaultLegacy(THEME);

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var build = {
  exports: {}
};

(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = isTouchDevice;

  function isTouchDevice() {
    return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
  }

  module.exports = exports['default'];
})(build, build.exports);

var isTouchDevice =
/*@__PURE__*/
getDefaultExportFromCjs(build.exports);
var BREAKPOINTS = THEME__default["default"].BREAKPOINTS;

var hover = function hover(style) {
  return {
    '&:hover': style
  };
};

var nonTouch = function nonTouch(style) {
  return isTouchDevice() ? null : style;
};

var touch = function touch(style) {
  return !isTouchDevice() ? null : style;
};

var fullVHExceptHeader = _defineProperty__default["default"]({
  height: 'calc(100vh - 70px)'
}, "@media (max-width: ".concat(BREAKPOINTS.SM, ")"), {
  height: 'calc(100vh - 50px)'
});

var fullVHExceptHeaderMin = _defineProperty__default["default"]({
  minHeight: 'calc(100vh - 70px)'
}, "@media (max-width: ".concat(BREAKPOINTS.SM, ")"), {
  minHeight: 'calc(100vh - 50px)'
});

var mediaTabletPortrait = function mediaTabletPortrait(style) {
  return _defineProperty__default["default"]({}, "@media (min-width: ".concat(BREAKPOINTS.SM, ") and (max-width: ").concat(BREAKPOINTS.LG, ") and (orientation: portrait)"), style);
};

var mediaPhonePortrait = function mediaPhonePortrait(style) {
  return _defineProperty__default["default"]({}, "@media (max-width: 767px) and (orientation: portrait)", style);
};

var mediaPhoneLandscape = function mediaPhoneLandscape(style) {
  return _defineProperty__default["default"]({}, "@media (max-width: 1024px) and (orientation: landscape)", style);
};

exports.fullVHExceptHeader = fullVHExceptHeader;
exports.fullVHExceptHeaderMin = fullVHExceptHeaderMin;
exports.hover = hover;
exports.mediaPhoneLandscape = mediaPhoneLandscape;
exports.mediaPhonePortrait = mediaPhonePortrait;
exports.mediaTabletPortrait = mediaTabletPortrait;
exports.nonTouch = nonTouch;
exports.touch = touch;